// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/inventari-fisici/:id',
    requestBody: null,
    response: '{ success: true, data: Testata + righe, logs: [...] }'
  },
  {
    method: 'PUT',
    endpoint: '/api/inventari-fisici/:id/righe/:rigaId',
    requestBody: '{ quantitaRilevata }',
    response: '{ success: true }'
  },
  {
    method: 'PUT',
    endpoint: '/api/inventari-fisici/:id',
    requestBody: '{ data, descrizione, note }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'GET',
    endpoint: '/api/inventari-fisici/lookup/articoli?societaId=&q=&inventarioId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, codice, descrizioneBase, tipologia }] }'
  },
  {
    method: 'POST',
    endpoint: '/api/inventari-fisici/:id/righe',
    requestBody: '{ articoloId, quantitaRilevata, note }',
    response: '{ success: true, data: { id, ordine } }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/inventari-fisici/:id/righe/:rigaId',
    requestBody: null,
    response: '{ success: true }'
  },
  {
    method: 'POST',
    endpoint: '/api/inventari-fisici/:id/conferma',
    requestBody: null,
    response: '{ success: true, data: { id, numero, anno, movimento, righeApplicate } }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/inventari-fisici/:id',
    requestBody: null,
    response: '{ success: true }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
